<div
    [hidden]="!toggle"
    class="nd-spinner-infinite-scroll">
    <app-nd-spinner [large]="true"></app-nd-spinner>
</div>
